__webpack_require__.p = "https://static.qic-uat.online/apps/renewfront/51c5c89b/en/";